import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

export const DetailsByTariffDialog = ({ open, handleClose }) => {
    const { t } = useTranslation()

    return (
        <ModalDialogWrapper
            handleClose={handleClose}
            open={open}
            footerActions={
                <>
                    <Button variant="contained" fullWidth onClick={handleClose}>
                        {t('detailsByTariffDialog.understood')}
                    </Button>
                </>
            }
            title={t('detailsByTariffDialog.title')}>
            <Typography variant="body2">
                {t('detailsByTariffDialog.noSubscription')}
            </Typography>
            <Typography variant="body2">{t('detailsByTariffDialog.coinsBalance')}</Typography>
            <ul>
                <li>
                    <Typography variant="body2">
                        {t('detailsByTariffDialog.coinsNotExpire')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body2">
                        {t('detailsByTariffDialog.levelActive')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body2">
                        {t('detailsByTariffDialog.autoFreeLevel')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body2">
                        {t('detailsByTariffDialog.canReplenish')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body2">
                        {t('detailsByTariffDialog.bonusCoins')}
                    </Typography>
                </li>
            </ul>
        </ModalDialogWrapper>
    )
}
